import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';
export var searchPharmacyRequests = function (config, patientAuthoringSystem, patientAuthoringSystemForeignKey, limit, filter) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable("api/v1/pharmacy-requests/" + patientAuthoringSystem + "/" + patientAuthoringSystemForeignKey + "/search?limit=" + limit, config, filter);
};
export function cancelPharmacyRequestByPatientAuthKeys(patientAuthoringSystem, patientAuthoringSystemForeignKey, cancellationDetails) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/pharmacy-requests/" + patientAuthoringSystem + "/" + patientAuthoringSystemForeignKey + "/cancel", cancellationDetails);
}
export function cancelPharmacyRequestByPatientId(patientId, cancellationDetails) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/pharmacy-requests/" + patientId + "/cancel", cancellationDetails);
}
export function stopPharmacyRequestByPatientAuthKeys(patientAuthoringSystem, patientAuthoringSystemForeignKey, stoppedDetails) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/pharmacy-requests/" + patientAuthoringSystem + "/" + patientAuthoringSystemForeignKey + "/stop", stoppedDetails);
}
export function stopPharmacyRequestByPatientId(patientId, stoppedDetails) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).put("api/v1/pharmacy-requests/" + patientId + "/stop", stoppedDetails);
}
export function createPharmacyRequest(data) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).post("api/v1/pharmacy-requests", data);
}
export function validatePharmacyRequestExpiry(data) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).post("api/v1/pharmacy-requests/validate-expiry", data);
}
export var pharmacyRequestHistorySummary = function (config, pharmacyRequestId) {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable("api/v1/pharmacy-requests/" + pharmacyRequestId + "/history", config);
};
